module.exports = __webpack_public_path__ + "static/media/keypa.0b1dd7fb.png";